// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElecStatistics_wrapper__1uJo7","content":"ElecStatistics_content__gfjDA"};